export default value => {
  return (
    value
      .replace(/\//g, '')
      .match(/.{1,2}/g)
      ?.join('/') || ''
  );
};
